import i18n from "@/i18n";
import { MODULE_TESTING_ORGANIZATIONS } from "@/constants/Permissions";

export default [
  {
    path: "/testing-organizations",
    name: "TestingOrganizations",
    meta: {
      title: String(i18n.t("sidebar.testing_organizations")),
      trans: "sidebar.testing_organizations",
      permissions: [MODULE_TESTING_ORGANIZATIONS],
    },
    component: () => import(/* webpackChunkName: "testing-organizations" */ "@/views/Exam/TestingOrganizations/TestingOrganizations.vue"),
  },
];
